import React, { useEffect, useMemo, useState } from 'react';
import ReactPhoneInput, { PhoneInputProps } from 'react-phone-input-2';
import { v4 as uuid } from 'uuid';
import 'react-phone-input-2/lib/style.css';

import { ErrorMessage } from '../ErrorMessage';

import './styles.scss';

interface Props extends PhoneInputProps {
    errors?: string[];
    hideErrorMessage?: boolean;
    className?: string;
    removeBorderRadius?: 'top' | 'bottom';
    tabIndex?: number;
    onChange: (value: string) => void;
}

export const PhoneInput = ({
    value,
    country,
    onlyCountries,
    preferredCountries,
    localization,
    className,
    errors,
    hideErrorMessage,
    removeBorderRadius,
    tabIndex,
    onChange,
}: Props) => {
    const [key, setKey] = useState('');
    useEffect(() => {
        setKey(uuid()); // Fixes issue with rerendering component after input config is passed
    }, [onlyCountries, localization, preferredCountries]);

    const handleChange = (value: string) => {
        onChange(value);
    };

    const borderRadiusClassName = useMemo(() => {
        switch (removeBorderRadius) {
            case 'top':
                return 'app-phone-input__input--no-top-border';
            case 'bottom':
                return 'app-phone-input__input--no-bottom-border';
            default:
                return '';
        }
    }, [removeBorderRadius]);

    return (
        <div className={`app-phone-input ${className}`}>
            <ReactPhoneInput
                inputClass={`app-phone-input__input ${
                    errors?.length ? 'app-phone-input__input--has-error' : ''
                } ${borderRadiusClassName}`}
                buttonClass='app-phone-input__button'
                dropdownClass='app-phone-input__dropdown'
                searchClass='app-phone-input__search-field'
                country={country || 'ua'}
                value={value}
                localization={localization}
                onlyCountries={onlyCountries}
                preferredCountries={preferredCountries}
                onChange={handleChange}
                key={key}
                inputProps={{ tabIndex }}
            />
            {!hideErrorMessage && <ErrorMessage errors={errors} />}
        </div>
    );
};
